<template>
  <div id="app">
    <img alt="UBENSE logo" src="../assets/logo.png" />
    <br />
    <b>LICENSE PLATE READER</b>
    <b-container>
      <div>
        <b-navbar toggleable="lg" type="dark" variant="info">
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <b-nav-item active to="/Restricted/">Dashboard</b-nav-item>
              <b-nav-item active to="/Restricted/ViewEvents">Plates</b-nav-item>
              <b-nav-item active to="/Restricted/CreateCamera">Cameras</b-nav-item>
              <b-nav-item active to="/Restricted/CreateSite">Sites</b-nav-item>
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-item-dropdown right text="Dropdown ARIA" variant="primary" class="m-2">
                <!-- Using 'button-content' slot -->
                <template v-slot:button-content>
                  <em>{{useremail}}</em>
                </template>
                <b-dropdown-item v-if="userrole==='admin'" to="/Restricted/AuditLog">Audit</b-dropdown-item>
                <b-dropdown-item v-if="userrole==='admin'" to="/Restricted/ViewPictures">Pictures</b-dropdown-item>                
                <b-dropdown-item to="/Restricted/Profile">Profile</b-dropdown-item>
                <b-dropdown-item to="/Restricted/Logout">Sign Out</b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
      <router-view />
    </b-container>
  </div>
</template>
<script>
import AmplifyStore from "../store/store";

export default {
  async created() {
    this.useremail = AmplifyStore.state.user.attributes["email"];
    this.userrole = AmplifyStore.state.user.attributes["custom:level"];
    if (!this.userrole) {
      this.userrole = "operator";
    }

    if (!this.useremail) {
      this.useremail = "User";
    }
  },
  data: () => {
    return {
      useremail: "",
      userrole: ""
    };
  }
};
</script>

<style>
nav li:hover,
nav li.active {
  background-color: rgb(235, 66, 60);
  cursor: pointer;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.card {
  margin: 0 auto; /* Added */
  float: none; /* Added */
  margin-bottom: 5px; /* Added */
}
</style>